import React from 'react';
import { ReactComponent as Logo } from './logo-pace.svg';
import './logo.scss';

export default function LogoPace() {
  return (
    <a href="https://www.interreg2seas.eu/" className="logo logo--pace" target="_blank" rel="noopener noreferrer">
      <Logo />
    </a>
  );
}
